import { render, staticRenderFns } from "./BiReport.vue?vue&type=template&id=1a94c968"
import script from "./BiReport.vue?vue&type=script&lang=js"
export * from "./BiReport.vue?vue&type=script&lang=js"
import style0 from "./BiReport.vue?vue&type=style&index=0&id=1a94c968&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports